import { Outlet } from "react-router-dom";
import Navbar from "../../components/student/nav/Navbar";

export default function Layout() {
	return (
		<>
			<Navbar />
			<Outlet />
		</>
	);
}
